import { Alert } from '@mui/material';
import { getErrorMessage } from 'lib/utils/getErrorMessage';

interface SaveErrorAlertProps {
  error: unknown;
}

// Shown when a step's save is rejected. Every wizard step needs this: without it a failed
// save is silent and the user keeps going, which is how one bad field cost a reporter five
// pages of work (ID 7).
const SaveErrorAlert = ({ error }: SaveErrorAlertProps) => {
  if (!error) return null;

  return (
    <Alert severity="error" sx={{ mt: 1 }}>
      {getErrorMessage(error)}
    </Alert>
  );
};

export default SaveErrorAlert;
